<app-navbar></app-navbar>

<app-sidebar [class.collapsed]="isSidebarCollapsed"></app-sidebar>

<main role="main" class="no-select main main_margin-left"
      [class.main_margin-left--collapsed]="isSidebarCollapsed">
  <router-outlet></router-outlet>
</main>

<!--<div class="chat-button"*ngIf="isLoggedIn">
  <internal-chat
    *ngIf="isInternalChatEnabled && isLoggedIn && auth.isRegistered"
    [id]="auth.userProfile.cognitoId"
    [name]="auth.userProfile.username"
    [avatarUrl]="auth.userProfile?.userData?.avatarUrl || auth.userProfile.avatarUrl"
  ></internal-chat>
</div> UI_CODE_CLEANUP -->

<!-- <app-footer></app-footer> -->
